import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Gift } from 'lucide-react';
import BisneLogo from '@/components/BisneLogo';
import api from '@/lib/api';

export default function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextUrl = searchParams.get('next');
  const refFromUrl = searchParams.get('ref') || '';
  const [refCode, setRefCode] = useState(refFromUrl);

  useEffect(() => {
    if (nextUrl) sessionStorage.setItem('bisne_next', nextUrl);
    api.get('/auth/me')
      .then(() => navigate(nextUrl || '/', { replace: true }))
      .catch(() => {});
  }, [navigate, nextUrl]);

  const handleGoogleLogin = () => {
    if (refCode.trim()) sessionStorage.setItem('bisne_ref', refCode.trim().toLowerCase());
    const redirectUrl = window.location.origin + '/';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="login-page" className="bg-background flex flex-col items-center justify-center p-8" style={{ minHeight: '100dvh' }}>
      <div className="w-full max-w-sm space-y-10 text-center">
        <div className="space-y-4">
          <BisneLogo size={72} className="text-primary mx-auto" />
          <h1 className="font-heading text-6xl sm:text-7xl text-primary tracking-tight">BISNE</h1>
          <p className="text-muted-foreground font-body text-base">El Marketplace de la Raza</p>
          <div className="border-t-4 border-primary w-16 mx-auto" />
        </div>
        <div className="space-y-3">
          <p className="text-foreground/80 text-sm font-body">Compra, vende y cambia con video.</p>
          <p className="text-primary/80 text-sm font-body font-bold">Ofrece tu articulo + efectivo.</p>
        </div>

        <div className="space-y-3">
          <div className="relative">
            <Gift className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
            <Input data-testid="login-referral-input" value={refCode} onChange={e => setRefCode(e.target.value)}
              placeholder="Codigo de referido (Opcional)"
              className="bg-zinc-900 border-zinc-800 font-body text-sm h-11 pl-10 rounded-xl" />
          </div>
          {refCode && <p className="text-primary/70 text-xs font-body">Ambos ganan $20 Bisne Cash</p>}
        </div>

        <Button data-testid="google-login-btn" onClick={handleGoogleLogin}
          className="w-full h-14 rounded-full font-body font-bold text-base bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/25">
          Iniciar con Google
        </Button>
        <p className="text-muted-foreground text-xs font-body">
          Al continuar, aceptas los{' '}
          <Link to="/terminos" data-testid="login-terms-link" className="text-primary underline underline-offset-2 hover:text-primary/80">terminos y condiciones</Link>
          {' '}y el{' '}
          <Link to="/privacidad" data-testid="login-privacy-link" className="text-primary underline underline-offset-2 hover:text-primary/80">aviso de privacidad</Link>
          {' '}de Bisne.
        </p>
      </div>
    </div>
  );
}
